import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { Ajuste, ajustes, ocorrenciaTipoToPermission } from 'service/api'
import { toast } from 'sonner'

interface Aprovacao {
    tipo: Ajuste['tipoAjuste']
    id: number
}

export default function AprovarVariosAjustesModal() {
    const navigate = useNavigate()
    let { ids }: { ids?: string | Aprovacao[] } = useParams()
    const { mutate } = ajustes.aprovacao.mutations.useUpdate({
        onSuccess: () => {
            ajustes.invalidateQueries()
        },
    })

    if (!ids) return navigate(-1) as never

    ids = ids
        .split(',')
        .map(id => ({
            tipo: (id.split('_')[0].charAt(0).toUpperCase() +
                id.split('_')[0].slice(1)) as Ajuste['tipoAjuste'],
            id: Number(id.split('_')[1]),
            hasPermission: hasPermission([
                'update',
                ocorrenciaTipoToPermission(id.split('_')[0] as any),
            ]),
        }))
        .filter(it => it.hasPermission)

    const handleSubmit: SubmitHandler<any> = async () => {
        ;(ids as Aprovacao[])?.map(({ tipo, id }) => {
            mutate(
                { id, tipo },
                {
                    onError: e => {
                        toast.error(e.message)
                    },
                },
            )
        })
        toast.success('Ajustes aprovados com sucesso')
        navigate(-1)
    }

    return (
        <Dialog.Root onSubmit={handleSubmit}>
            <Dialog.Title>Aprovar ajustes</Dialog.Title>
            <Dialog.Content>
                Você está prestes a aprovar {ids?.length} ajustes de ponto. Tem
                certeza que deseja continuar?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton>Sim</Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
